<template>
    <div class="d-flex">
        <b-button
            variant="default"
            @click="(showModal = true), (deviceName = name), (deviceActive = isActive)"
            style="margin-left: 5px"
            >Edit</b-button
        >

        <Modal
            id="edit-device-modal"
            title="Edit Device"
            ok-title="Save"
            @hide="showModal = false"
            @cancel="showModal = false"
            @ok="save"
            :visible="showModal"
        >
            <Input v-model="deviceName" label="Device Name:" />

            <div class="push-label-group">
                <label class="m-0">Push Notifications:</label>
                <div>
                    <form-switch v-model="deviceActive" />
                    <span @click="$bvModal.show('push-notification-notice-modal')">
                        <font-awesome-icon
                            class="text-secondary"
                            style="cursor: pointer; margin-left: 10px; width: 20px; height: 20px"
                            :icon="['fas', 'circle-info']"
                            title="Push Notification Notice"
                        />
                    </span>
                </div>
            </div>

            <div>
                <Modal id="push-notification-notice-modal" title="Push Notification Notice" ok-only>
                    <label
                        >Make sure to have push notification permissions always enabled on the device itself. iOS and
                        Android require permission within the device settings for the Lodgix App. Most web browsers
                        require user permissions within the browser settings before allowing push notifications from
                        Lodgix.com. App and web browser permissions is seperate from Lodgix.</label
                    >
                </Modal>
            </div>
        </Modal>
    </div>
</template>

<script>
import API from '../../api';
import { FCM_DEVICE_ENDPOINT } from '../../endpoints';
import { formatResponseError } from '../../utils/api';
import Modal from '../generic/modal/modal.vue';
import Input from '../generic/form-input/form-input.vue';
import formSwitch from '../generic/form-switch/form-switch.vue';

export default {
    components: {
        Modal,
        Input,
        formSwitch,
    },
    computed: {
        isActive() {
            return this.params.data.active;
        },
        token() {
            return this.params.data.registration_id;
        },
        type() {
            return this.params.data.type;
        },
        name() {
            return this.params.data.name;
        },
    },
    data() {
        return {
            showModal: false,
            deviceName: '',
            deviceActive: true,
        };
    },
    methods: {
        async setStatus(value) {
            /*try {
                    await API.post(`${FCM_DEVICE_ENDPOINT()}`, {
                        registration_id: this.token,
                        active: value,
                        type: this.type,
                    });
                    this.params.data.active = value;
                    this.params.refresh();
                } catch (error) {
                    const { generic } = formatResponseError(error);
                    this.errorToast({ text: generic || 'Could not delete device' });
                } finally {
                    this.busy = false;
                }*/
        },
        async save() {
            try {
                await API.post(`${FCM_DEVICE_ENDPOINT()}`, {
                    registration_id: this.token,
                    active: this.deviceActive,
                    type: this.type,
                    name: this.deviceName,
                });
                this.params.data.name = this.deviceName;
                this.params.refresh();
            } catch (error) {
                const { generic } = formatResponseError(error);
                this.errorToast({ text: generic || 'Could not update device information' });
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.iframe-content {
    border: none;
}
</style>
<style>
.communication-iframe-modal {
    min-height: 400px;
}
.push-label-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
</style>
